/**
 * Contract-form field policy.
 *
 * The generic rules live in `@utriper/core` (`trimToNull`, `isValidHttpUrl`). What stays here
 * is what belongs to this field rather than to every URL everywhere: that it is **optional**,
 * and which message to show when it is not acceptable.
 */

import { trimToNull, isValidHttpUrl } from '@utriper/core';

/**
 * react-final-form validator for the contract redirect URL.
 *
 * Empty is acceptable — clearing the field is how a contract owner turns the redirect off,
 * and `apiserver` treats the resulting NULL as "no redirect configured" (roadmap#686).
 *
 * @param {string|null|undefined} value
 * @returns {string|undefined} A translation key when invalid, otherwise undefined.
 */
export const validateContractRedirectUrl = (value) =>
    trimToNull(value) && !isValidHttpUrl(value) ? 'contract.redirectUrlInvalid' : undefined;
